import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

interface GAListenerProps {
  children: ReactNode;
}

export const GAListener: React.FC<GAListenerProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return <>{children}</>;
};
